import { useLenis } from "@/hooks/useLenis";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { MarqueeStrip } from "@/components/site/MarqueeStrip";
import { Nosotros } from "@/components/site/Nosotros";
import { Servicios } from "@/components/site/Servicios";
import { Formalizacion } from "@/components/site/Formalizacion";
import { PlanesSuscripcion } from "@/components/site/PlanesSuscripcion";
import { Plataformas } from "@/components/site/Plataformas";
import { Contacto } from "@/components/site/Contacto";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  useLenis();
  return (
    <div className="bg-vnavy min-h-screen" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <MarqueeStrip />
        <Nosotros />
        <Servicios />
        <Formalizacion />
        <PlanesSuscripcion />
        <Plataformas />
        <Contacto />
      </main>
      <Footer />
    </div>
  );
}
